import { ReactNode, useState } from 'react';
import { ChannelType } from '../../../gql/generated';
import {
  AddChannelDialogContext,
  AddChannelDialogContextValue,
  ChannelFormData,
} from './context';

interface AddChannelDialogProviderProps {
  children: ReactNode;
  initialFormData?: Partial<ChannelFormData>;
}

export function AddChannelDialogProvider({
  children,
  initialFormData,
}: AddChannelDialogProviderProps) {
  const [formData, setFormData] = useState<ChannelFormData>({
    name: '',
    channelType: ChannelType.Email,
    isActive: true,
    email: '',
    teamsWebhookUrl: '',
    groupedChannelIds: [],
    ...initialFormData,
  });

  const updateFormData = (updates: Partial<ChannelFormData>) => {
    setFormData((prev) => ({ ...prev, ...updates }));
  };

  const value: AddChannelDialogContextValue = {
    formData,
    setFormData,
    updateFormData,
  };

  return (
    <AddChannelDialogContext.Provider value={value}>
      {children}
    </AddChannelDialogContext.Provider>
  );
}
